
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class PieChart extends Vue {
  @Prop({ type: Number, default: 0 }) readonly percentage!: number;

  @Prop({ type: String, required: true }) readonly color!: string;

  private radius = 16;

  get circumference(): number {
    return 2 * Math.PI * this.radius;
  }

  get coloredPart(): number {
    return (this.circumference * (this.percentage ?? 0)) / 100;
  }

  get backgroundPart(): number {
    return this.circumference - this.coloredPart;
  }
}
